module.exports = __webpack_public_path__ + "img/9_81.730ce07a.png";